import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Dashboard_Statics_Table_Header } from "../../../utils/helperData";

const formatCategoryName = (key) => {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
const DashboardStaticsTable = ({ data }) => {
  if (!data || typeof data !== "object") {
    return (
      <div className="flex justify-center pt-5">
        <p>No data available</p>
      </div>
    );
  }

  const createDataRows = () => {
    const rows = [];
    for (const [key, value] of Object.entries(data)) {
      rows.push({
        category: formatCategoryName(key),
        totalValid: value.total_valid_form,
        totalInvalid: value.total_invalid_form,
        totalError: value.total_error,
      });
    }
    return rows;
  };

  const rows = createDataRows();

  return (
    <div className="flex justify-center overflow-auto pt-5">
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          overflow: "auto",
          border: "1px solid #E2E8F0",
          borderRadius: "12px",
          boxShadow: "none",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {Dashboard_Statics_Table_Header.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#334155",
                    backgroundColor: "#F8FAFC",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:hover": {
                    backgroundColor: "#F8FAFC",
                    margin: "center",
                  },
                }}
              >
                <TableCell
                  sx={{ fontSize: "14px", color: "#475569", fontWeight: 500 }}
                >
                  {row.category}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "14px", color: "#475569", fontWeight: 500 }}
                >
                  {row.totalValid}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "14px", color: "#475569", fontWeight: 500 }}
                >
                  {row.totalInvalid}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "14px", color: "#475569", fontWeight: 500 }}
                >
                  {row.totalError}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default DashboardStaticsTable;
